import { Button } from '@mui/material'

// Imports custom
import { FileManagerList, TooltipInformation } from 'common'

export const FilesTable = ({ useFetchInit }) => {
    
    const {
        //------------- Generales
        // location,
        // paramsURL,
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    const { formOpeningMode } = globalStates 
    // ------------------------------------------------ Helpers
    // ------------------------------------------------ Formularios
    // ------------------------------------------------ FetchData
    const { fetchAllFiles } = FetchData
    const { dataFiles } = fetchAllFiles
    // ------------------------------------------------ Actions
    const { handleClickDeleteDocument } = Actions

    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info", 
            minWidth: 80,
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const {iddocumento, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                return(
                    <>
                        <TooltipInformation 
                            idregistro={iddocumento}
                            usuario_creo={usuario_creo}
                            fecha_creo={fecha_creo}
                            usuario_modifico={usuario_modifico}
                            fecha_modifico={fecha_modifico}
                        />
                    </>
                    
                )
            }
        },
        { field: "document_originalname", headerName: "NOMBRE DEL ARCHIVO", minWidth: 250, filter: true },
        { field: "department", headerName: "DEPARTAMENTO", minWidth: 250, filter: true },
        {
            headerName: "OPCIONES",minWidth: 300,
            cellRenderer: (params) => {

                const { iddocumento, document_path, department } = params.data
        
                if (formOpeningMode==='EDITABLE') return(
                    
                    <>
                        <Button
                            variant='contained' 
                            size='small' 
                            href={document_path} 
                            target="_blank" 
                            color='success' 
                            style={ { marginRight: '0.4vh' } }> 
                            <i className="fa-solid fa-download" style={{ marginRight: '8px' }}></i> Descargar
                        </Button>

                        {/* {(department !== 'JURIDICO') && ( */}
                        <Button 
                            variant='contained' 
                            size='small' 
                            onClick={() => handleClickDeleteDocument(iddocumento)}  
                            color='error' 
                            style={ { marginRight: '0.4vh' } }
                            disabled={(department !== 'ADMINISTRADOR') ? true : false}
                        >
                            <i className="fa-solid fa-trash" style={{ marginRight: '8px' }}></i> Eliminar
                        </Button>
                        {/* )} */}
                        
                    </>
                    
                )
        
                return (
                    <>
                        <Button
                            variant='contained' 
                            size='small' 
                            href={document_path} 
                            target="_blank" 
                            color='success' 
                            style={ { marginRight: '0.4vh' } }> 
                            <i className="fa-solid fa-download" style={{ marginRight: '8px' }}></i> Descargar
                        </Button>
                    </>
        
                )
                
            }
        },
    ]

    
    return (
        //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
        <div className='content'>
            <FileManagerList
                // datos (listados, individuales)
                rowConfig={dataFiles}
                columnConfig={columnConfig}

                // HandleClicks

                // Funciones
            />
        </div>
    )
    
}